module.exports = __webpack_public_path__ + "img/search.b888e2f1.svg";